export default __webpack_public_path__ + "static/media/Drum_img_04.327b7941.png";